"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _reactRouterDom = require("react-router-dom");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _InspirationsHeader = _interopRequireDefault(require("../../../../common/components/InspirationsHeader"));

require("./styles/_home-header.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var TITLE = 'Get Inspired! Get Creative!';

var HomeHeader = /*#__PURE__*/function (_Component) {
  _inherits(HomeHeader, _Component);

  function HomeHeader(props) {
    var _this;

    _classCallCheck(this, HomeHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HomeHeader).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onFiltersChange", function () {
      var onFiltersChange = _this.props.onFiltersChange;
      var searchTerm = _this.state.searchTerm;
      var filters = !searchTerm ? void 0 : {
        searchTerm: searchTerm
      };
      onFiltersChange(filters);
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", (0, _lodash.default)(function (searchTags) {
      _this.setState({
        searchTerm: searchTags
      });

      _this.onFiltersChange();
    }, 300));

    _this.state = {
      searchTerm: ''
    };
    return _this;
  }

  _createClass(HomeHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          history = _this$props.history,
          getInspirationsHeader = _this$props.getInspirationsHeader,
          selectedInspirationOrgId = _this$props.selectedInspirationOrgId;
      return _react.default.createElement(_InspirationsHeader.default, {
        getInspirationsHeader: getInspirationsHeader,
        className: "home-header",
        selectedInspirationOrgId: selectedInspirationOrgId
      }, _react.default.createElement("div", {
        className: "home-header__setting-icon"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "settings",
        color: "white",
        onClick: function onClick() {
          return history.push('/manage');
        }
      })), _react.default.createElement("div", {
        className: "home-header__content"
      }, _react.default.createElement("h3", null, TITLE), _react.default.createElement(_uiKit.TagInput, {
        placeholder: "Search Inspirations",
        onChange: this.onSearch
      })), _react.default.createElement("div", {
        className: "home-header__view-favourites"
      }, _react.default.createElement(_reactRouterDom.Link, {
        to: "/inspiration/favourite-posts"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "favfull",
        size: 20,
        color: "white"
      }), "VIEW FAVOURITES")));
    }
  }]);

  return HomeHeader;
}(_react.Component);

exports.default = HomeHeader;